<template>
  <v-container class="py-0 px-0" fluid>
    <v-card>
      <v-card-text class="px-6 py-6">
        <v-row>
          <v-col cols="6" class="py-0">
            <v-img class="img-tip" :src="require('@/assets/offline-number-tip-v2.png')" />
          </v-col>
          <v-col cols="6">
            <p class="card-title px-0 pb-2">Número offline?</p>
            <p class="texto-corrido">Tente esses passos:</p>
            <p class="texto-corrido">1. Desbloqueie seu celular</p>
            <p class="texto-corrido">2. Aguarde com a tela ativa, por até 3 minutos</p>
            <p class="texto-corrido">Se sua conexão não voltar, remova o número da plataforma e insira novamente.</p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  name: 'OfflineNumberTip',
}
</script>
